module.exports = __webpack_public_path__ + "static/Gain_panel-c35f1ac8bfd6d7233cf2db1e338ef90f.png";